/* EVENTS */
export const GET_ARTICLE = "GET_ARTICLE"
export const GET_ARTICLE_SUCCESS = "GET_ARTICLE_SUCCESS"
export const GET_ARTICLE_FAIL = "GET_ARTICLE_FAIL"

export const GET_ARTICLE_DETAILS = "GET_ARTICLE_DETAILS"
export const GET_ARTICLE_DETAILS_SUCCESS = "GET_ARTICLE_DETAILS_SUCCESS"
export const GET_ARTICLE_DETAILS_FAIL = "GET_ARTICLE_DETAILS_FAIL"

export const ADD_NEW_ARTICLE = "ADD_NEW_ARTICLE"
export const ADD_ARTICLE_SUCCESS = "ADD_ARTICLE_SUCCESS"
export const ADD_ARTICLE_FAIL = "ADD_ARTICLE_FAIL"

export const UPDATE_ARTICLE = "UPDATE_ARTICLE"
export const UPDATE_ARTICLE_SUCCESS = "UPDATE_ARTICLE_SUCCESS"
export const UPDATE_ARTICLE_FAIL = "UPDATE_ARTICLE_FAIL"

export const DELETE_ARTICLE = "DELETE_ARTICLE"
export const DELETE_ARTICLE_SUCCESS = "DELETE_ARTICLE_SUCCESS"
export const DELETE_ARTICLE_FAIL = "DELETE_ARTICLE_FAIL"

export const RESET_ARTICLE_STATE = 'RESET_ARTICLE_STATE';
